export default "__VITE_ASSET__6087c12a__"